import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { HhsgSharedStuderEmployee } from "../../models/sgportal-data-api-models/employee.model";
import { HhsgSharedConfigService } from "../config.service";
import { HhsgSharedHttpService } from "../http.service";

@Injectable()
export class HhsgSharedStuderEmployeeService {
    private readonly _apiServer: string;
    private readonly _controllerName = "Employee";

    constructor(private _configService: HhsgSharedConfigService, private _httpService: HhsgSharedHttpService) { 
        this._apiServer = _configService.appSettings.sgPortalApiServer;
    }

    public async GetEmployee(employeeId: number, organizationId: number): Promise<HhsgSharedStuderEmployee> {
        if (!this._apiServer || this._apiServer.trim() == '') {
            return new HhsgSharedStuderEmployee();
        }

		return await this._httpService.doGetRequestAsync<HhsgSharedStuderEmployee>(
            this._apiServer, 
            this._controllerName, 
            `GetEmployee/${employeeId}/${organizationId}`);		
	}

    public GetEmployeesByEmail(email: string): Observable<HhsgSharedStuderEmployee[]> {
        if (!this._apiServer || this._apiServer.trim() == '') {
            return of(undefined);
        }

		return this._httpService.doGetRequestObservable<HhsgSharedStuderEmployee[]>(this._apiServer, this._controllerName, `GetEmployeesByEmail/${email}`);
	}

    public async saveEmployee2(newEmpRequest: HhsgSharedStuderEmployee): Promise<HhsgSharedStuderEmployee> {
        if (!this._apiServer || this._apiServer.trim() == '') {
            return new HhsgSharedStuderEmployee();
        }

		return await this._httpService.doPostRequestAsync<any, HhsgSharedStuderEmployee>(
            this._apiServer, 
            this._controllerName, 
            'SaveEmployee2', 
            newEmpRequest);
	}
}